import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext.jsx";

/** Non-admin → connexion. Post-login always lands on /accueil (no returnTo). */
export function AdminGuard({ children }) {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return <Navigate to="/connexion" replace />;
  }

  return children;
}
